import { render, staticRenderFns } from "./mc-serve.vue?vue&type=template&id=6b637803&scoped=true"
import script from "./mc-serve.vue?vue&type=script&lang=ts"
export * from "./mc-serve.vue?vue&type=script&lang=ts"
import style0 from "./mc-serve.vue?vue&type=style&index=0&id=6b637803&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b637803",
  null
  
)

export default component.exports